import { ISelectOptions } from 'context';

import { MethodistGroupOptionsQuery } from 'core/graphql';

export interface IMethodistGroupOptions {
  courseOptions: ISelectOptions[];
  groupOptions: ISelectOptions[];
}

export const transformMethodistGroupOptions = (
  data?: MethodistGroupOptionsQuery,
): IMethodistGroupOptions => {
  const groupOptions: ISelectOptions[] = [];
  const coursesById = new Map<string, ISelectOptions>();

  const edges = data?.allGroupsForLms?.edges || [];

  edges.forEach((edge) => {
    const node = edge?.node;
    if (node && node.__typename === 'MethodistGroupType') {
      groupOptions.push({ value: node.id, label: node.name });

      // Groups of one course repeat the course — dedupe by course.id.
      if (!coursesById.has(node.course.id)) {
        coursesById.set(node.course.id, { value: node.course.id, label: node.course.name });
      }
    }
  });

  return {
    courseOptions: Array.from(coursesById.values()),
    groupOptions,
  };
};
